import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Button, { ButtonColor, ButtonSize } from '../buttons/Button';
import css from './BusinessInductionBanner.module.scss';

interface Props extends React.HTMLProps<{}> {}

const BusinessInductionBanner = ({ intl }: Props & InjectedIntlProps) => {
  const intlPref = 'components.common.banners.businessInductionBanner.';

  return (
    <div className={css.BusinessInductionBanner}>
      <div className={css.BusinessInductionBanner__Inner}>
        <p className={css.BusinessInductionBanner__Copy1}>
          {intl.formatMessage({ id: intlPref + 'copy1' })}
        </p>
        <p className={css.BusinessInductionBanner__Copy2}>
          {intl.formatMessage({ id: intlPref + 'copy2' })}
        </p>
        <p className={css.BusinessInductionBanner__Copy3}>
          {intl.formatMessage({ id: intlPref + 'copy3' })}
        </p>
        <div className={css.BusinessInductionBanner__Button}>
          <Button
            buttonColor={ButtonColor.WhiteBiz}
            buttonSize={ButtonSize.Medium}
            href={'https://stores.jp/reserve'}
          >
            {intl.formatMessage({ id: intlPref + 'button' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(BusinessInductionBanner);
